/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "common";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface FlightPhaseEnum {
}

export enum FlightPhaseEnum_Enum {
  UNKNOWN = 0,
  REST = 12,
  CONFIGURING = 22,
  PREP_CLEANUP = 19,
  PREP = 1,
  WAIT_FOR_ARM = 6,
  LOGGING_START = 17,
  PERCH = 21,
  FLIGHT_PROCESSES_CHECK = 14,
  SAFETY_CHECK = 15,
  PRE_FLIGHT_INSPECTION = 23,
  READY_FOR_HAND_TAKEOFF = 16,
  HAND_TAKEOFF_PREP = 8,
  FLYING = 4,
  TEGRA_REBOOT_PREP = 18,
  ARMED_IN_DOCK = 20,
  POST_FLIGHT = 13,
  UNRECOGNIZED = -1,
}

export function flightPhaseEnum_EnumFromJSON(object: any): FlightPhaseEnum_Enum {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return FlightPhaseEnum_Enum.UNKNOWN;
    case 12:
    case "REST":
      return FlightPhaseEnum_Enum.REST;
    case 22:
    case "CONFIGURING":
      return FlightPhaseEnum_Enum.CONFIGURING;
    case 19:
    case "PREP_CLEANUP":
      return FlightPhaseEnum_Enum.PREP_CLEANUP;
    case 1:
    case "PREP":
      return FlightPhaseEnum_Enum.PREP;
    case 6:
    case "WAIT_FOR_ARM":
      return FlightPhaseEnum_Enum.WAIT_FOR_ARM;
    case 17:
    case "LOGGING_START":
      return FlightPhaseEnum_Enum.LOGGING_START;
    case 21:
    case "PERCH":
      return FlightPhaseEnum_Enum.PERCH;
    case 14:
    case "FLIGHT_PROCESSES_CHECK":
      return FlightPhaseEnum_Enum.FLIGHT_PROCESSES_CHECK;
    case 15:
    case "SAFETY_CHECK":
      return FlightPhaseEnum_Enum.SAFETY_CHECK;
    case 23:
    case "PRE_FLIGHT_INSPECTION":
      return FlightPhaseEnum_Enum.PRE_FLIGHT_INSPECTION;
    case 16:
    case "READY_FOR_HAND_TAKEOFF":
      return FlightPhaseEnum_Enum.READY_FOR_HAND_TAKEOFF;
    case 8:
    case "HAND_TAKEOFF_PREP":
      return FlightPhaseEnum_Enum.HAND_TAKEOFF_PREP;
    case 4:
    case "FLYING":
      return FlightPhaseEnum_Enum.FLYING;
    case 18:
    case "TEGRA_REBOOT_PREP":
      return FlightPhaseEnum_Enum.TEGRA_REBOOT_PREP;
    case 20:
    case "ARMED_IN_DOCK":
      return FlightPhaseEnum_Enum.ARMED_IN_DOCK;
    case 13:
    case "POST_FLIGHT":
      return FlightPhaseEnum_Enum.POST_FLIGHT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return FlightPhaseEnum_Enum.UNRECOGNIZED;
  }
}

export function flightPhaseEnum_EnumToJSON(object: FlightPhaseEnum_Enum): string {
  switch (object) {
    case FlightPhaseEnum_Enum.UNKNOWN:
      return "UNKNOWN";
    case FlightPhaseEnum_Enum.REST:
      return "REST";
    case FlightPhaseEnum_Enum.CONFIGURING:
      return "CONFIGURING";
    case FlightPhaseEnum_Enum.PREP_CLEANUP:
      return "PREP_CLEANUP";
    case FlightPhaseEnum_Enum.PREP:
      return "PREP";
    case FlightPhaseEnum_Enum.WAIT_FOR_ARM:
      return "WAIT_FOR_ARM";
    case FlightPhaseEnum_Enum.LOGGING_START:
      return "LOGGING_START";
    case FlightPhaseEnum_Enum.PERCH:
      return "PERCH";
    case FlightPhaseEnum_Enum.FLIGHT_PROCESSES_CHECK:
      return "FLIGHT_PROCESSES_CHECK";
    case FlightPhaseEnum_Enum.SAFETY_CHECK:
      return "SAFETY_CHECK";
    case FlightPhaseEnum_Enum.PRE_FLIGHT_INSPECTION:
      return "PRE_FLIGHT_INSPECTION";
    case FlightPhaseEnum_Enum.READY_FOR_HAND_TAKEOFF:
      return "READY_FOR_HAND_TAKEOFF";
    case FlightPhaseEnum_Enum.HAND_TAKEOFF_PREP:
      return "HAND_TAKEOFF_PREP";
    case FlightPhaseEnum_Enum.FLYING:
      return "FLYING";
    case FlightPhaseEnum_Enum.TEGRA_REBOOT_PREP:
      return "TEGRA_REBOOT_PREP";
    case FlightPhaseEnum_Enum.ARMED_IN_DOCK:
      return "ARMED_IN_DOCK";
    case FlightPhaseEnum_Enum.POST_FLIGHT:
      return "POST_FLIGHT";
    case FlightPhaseEnum_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseFlightPhaseEnum(): FlightPhaseEnum {
  return {};
}

export const FlightPhaseEnum = {
  encode(_: FlightPhaseEnum, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): FlightPhaseEnum {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFlightPhaseEnum();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): FlightPhaseEnum {
    return {};
  },

  toJSON(_: FlightPhaseEnum): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<FlightPhaseEnum>, I>>(base?: I): FlightPhaseEnum {
    return FlightPhaseEnum.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FlightPhaseEnum>, I>>(_: I): FlightPhaseEnum {
    const message = createBaseFlightPhaseEnum();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
